<div class="export-media-grid px-4">
    <div class="card export-media-card" *ngFor="let place of places" [class.export-media-card--expired]="place.isExpired">

        <!-- ===== État vide : aucun média associé ===== -->
        <div *ngIf="isEmptyPlace(place); else filledTpl" class="export-media-empty">
            <span class="export-media-empty-icon"><fa-icon [icon]="faImage"></fa-icon></span>
            <span class="export-media-empty-name">{{ place.name }}</span>
            <button *ngIf="!disabled" type="button" class="btn btn-sm btn-outline-primary export-media-empty-btn"
                (click)="openImportModal(place)">
                <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>{{ "export.addMedia" | translate }}
            </button>
        </div>

        <!-- ===== État rempli : média DAM ou lien associé ===== -->
        <ng-template #filledTpl>
            <div class="export-media-thumb">
                <span *ngIf="place.isExpired; else linkedTpl" class="export-media-status export-media-status--expired">
                    <fa-icon [icon]="faClock" class="mr-1"></fa-icon>{{ "dam.expire" | translate | uppercase }}
                </span>
                <ng-template #linkedTpl>
                    <span class="export-media-status export-media-status--linked"><fa-icon [icon]="faCheckCircle"></fa-icon></span>
                </ng-template>

                <img *ngIf="hasDamMedia(place)" [src]="getMediaImg(place)" class="export-media-img"
                    [title]="place.isExpired ? (_translate.instant('dam.expired') + place.dateValid) : ''" />
                <img *ngIf="hasLinkMedia(place)" [src]="getLinkImg(place)" class="export-media-img"
                    (error)="_thumbnailService.setDefaultImage($event)" />
            </div>

            <div class="card-body export-media-body">
                <div class="export-media-head">
                    <span class="export-media-title text-truncate" [ngbTooltip]="place.name" container="body">{{ place.name }}</span>
                    <span *ngIf="hasLinkMedia(place)" class="export-media-type-badge">{{ "general.link" | translate }}</span>
                </div>

                <div class="export-media-meta">
                    <div *ngIf="hasDimensions(place)" class="export-media-meta-row">
                        <fa-icon [icon]="faVectorSquare"></fa-icon>
                        <span>{{ getDimensions(place) }} px</span>
                    </div>
                    <div *ngIf="place.dateValid" class="export-media-meta-row" [class.export-media-meta-row--expired]="place.isExpired">
                        <fa-icon [icon]="faClock"></fa-icon>
                        <span>{{ "dam.dateValid" | translate }} : {{ place.dateValid }}</span>
                    </div>
                    <div *ngIf="place.copyright" class="export-media-meta-row">
                        <fa-icon [icon]="faCopyright"></fa-icon>
                        <span [ngbTooltip]="place.copyright" container="body">{{ place.copyright }}</span>
                    </div>
                    <div *ngIf="place.legend" class="export-media-meta-row">
                        <fa-icon [icon]="faAlignLeft"></fa-icon>
                        <span [ngbTooltip]="place.legend" container="body">{{ place.legend }}</span>
                    </div>
                </div>
            </div>

            <div class="card-footer export-media-footer" *ngIf="!disabled">
                <button *ngIf="hasDamMedia(place) && canCrop(place)" type="button"
                    class="export-media-action export-media-action--warning"
                    [ngbTooltip]="'dam.crop' | translate" container="body" (click)="openCrop(place)">
                    <fa-icon [icon]="faCrop"></fa-icon>
                </button>
                <button *ngIf="hasDamMedia(place) && !canCrop(place)" type="button"
                    class="export-media-action export-media-action--warning"
                    pTooltip="{{ 'projects.template.noPosPhotoSize' | translate }}" disabled>
                    <fa-icon [icon]="faCrop"></fa-icon>
                </button>

                <button type="button" class="export-media-action"
                    [ngbTooltip]="'projects.select' | translate" container="body" (click)="changeMedia(place)">
                    <fa-icon [icon]="faSyncAlt"></fa-icon>
                </button>

                <button *ngIf="hasDamMedia(place)" type="button" class="export-media-action"
                    [ngbTooltip]="'dam.metadata.title' | translate" container="body" (click)="openFieldModal(place)">
                    <fa-icon [icon]="faEdit"></fa-icon>
                </button>

                <button type="button" class="export-media-action export-media-action--danger"
                    [ngbTooltip]="'general.remove' | translate" container="body" (click)="unselected(place)">
                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                </button>
            </div>
        </ng-template>
    </div>
</div>

<app-cropper #cropper (cropped)="cropMedia($event)" (removeCrop)="removeCrop()" [module]="'projects'"></app-cropper>

<swal #mediaSwal [width]="'95%'" title="{{ 'projects.select' | translate }}" [showCancelButton]="true"
    [cancelButtonColor]="'#FF0000'" cancelButtonText="{{ 'general.close' | translate }}" [showConfirmButton]="false"
    (cancel)="resetSelectedMedias()" (close)="resetSelectedMedias()">
    <div *swalPortal class="row px-4">
        <!-- <div class="ml-2 mr-2" *ngFor="let media of medias">
            <div class="card" style="max-width: 10rem; min-width: 10rem;">
                <div class="card-header text-truncate">{{ media.name }}</div> -->
        <!-- <img [src]="'data:image/png;base64,' + media.thumb" class="card-img-top" [style]="'transform: rotate('+place.rotate+'deg) scaleX('+(place.flipHorizontal ? -1 : 1)+') scaleY('+(place.flipVertically ? -1 : 1)+')'" alt="Card media cap" /> -->

        <!-- <img [src]="media.thumbPath ? damUrl+media.thumbPath : 'data:image/png;base64,' + media.thumb"
                    class="card-img-top card-body-img-fixed-height maestro-background-checkerboard"
                    alt="Card media cap" />
                <div class="card-footer justify-content-end">
                    <div class="btn-group text-right" role="group">
                        <button type="button" class="btn btn-primary" (click)="selectMedia(media)">
                            <fa-icon [icon]="faHandPointer"></fa-icon>
                        </button>
                        <a type="button" class="btn btn-warning" (click)="openCrop(currentPlace, media)">
                            <fa-icon [icon]="faCrop"></fa-icon>
                        </a>
                    </div>
                </div>
            </div>
        </div> -->
        <div *ngIf="filters.tags.length" class="tags mb-1">
            <span class="mr-1">{{ 'filter.tag' | translate }} : </span>

            <span *ngFor="let tag of filters.tags" class="badge badge-pill badge-primary mr-1">
                <span class="mr-1">{{ tag.name }}</span>
                <span class="pointer" (click)="manageFilter(tag, false)">x</span>
            </span>
        </div>
        <div *ngIf="filters.type.length" class="mb-1">
            <span class="mr-1">{{ 'filter.extension' | translate }} : </span>

            <span *ngFor="let ext of filters.type" class="badge badge-pill badge-primary mr-1">
                <span class="mr-1">{{ ext.id }}</span>
                <span class="pointer" (click)="manageFilter(ext, false, 'type')">x</span>
            </span>
        </div>
        <app-dataview titleNotTooltip="pim.medias" type="page" [dataviewContent]="medias"
            (lazyEvent)="getMedias($event)" (searchEvent)="loadListWithSearch($event)" [minified]="true"
            (selectMedia)="selectMedia($event)" (openCrop)="openCropMedia($event)"
            [events]="eventsSubject.asObservable()" [totalRecords]="recordsFiltered" [buttons]="buttons"
            [sortOptions]="sortOptions" [poppedUp]="true" (tagFiltered)="manageFilter($event)"
            (filterExpireMedia)="changeHideExpireMedia($event)" [searchByTag]="false"
            (selectExtension)="manageFilter($event, true, 'type')" style="width: 100%;">
        </app-dataview><!-- @TODO Find a way to keep filters & pagination working with links in addition-->
    </div>
</swal>

<swal #importSwal [width]="'460px'" [showConfirmButton]="false" [showCancelButton]="false" [showCloseButton]="true"
    [customClass]="{ popup: 'export-upload-popup' }">
    <div *swalPortal>
        <div class="export-upload" [class.is-dragover]="isDragover"
            (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
            <div class="export-upload-icon"><fa-icon [icon]="faCloudUploadAlt"></fa-icon></div>
            <p class="export-upload-title">{{ "import.dropTitle" | translate }}</p>
            <p class="export-upload-or">{{ "import.or" | translate }}</p>

            <button type="button" class="export-upload-search" (click)="searchFromPopup()">
                <fa-icon [icon]="faSearch" class="mr-2"></fa-icon>{{ "export.searchProduct" | translate }}
            </button>

            <button *ngIf="activatedModules.dam" type="button" class="export-upload-search-dam" (click)="searchDamFromPopup()">
                <fa-icon [icon]="faImages" class="mr-2"></fa-icon>{{ "export.searchDam" | translate }}
            </button>

            <label class="export-upload-computer">
                <fa-icon [icon]="faLaptop" class="mr-2"></fa-icon>{{ "export.importComputer" | translate }}
                <input type="file" accept="image/*" (change)="onFileSelected($event)" />
            </label>

            <p class="export-upload-formats">{{ "upload.acceptedFormats" | translate }} {{ acceptedFormatsLabel }}</p>
            <p class="export-upload-maxsize">{{ "upload.maxSize" | translate: { size: maxFileSizeLabel } }}</p>
        </div>
    </div>
</swal>
